import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import { TRANSLATIONS as translation } from '../../../../../../../utils/constant.utils';
import {
    ORFButton as Button
    , OR_RRF_InputField as InputField
    , OR_RRF_Select as Select
    , ORFDropdownCheckbox
} from '../../../../../../common/forms/order-request-form.component';
import { newQuotationActions } from "./../../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-quotation.reducer";

class QuotationSubscriptionForm extends Component {
    constructor(props) {
        super(props);
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {
        const {
            //component props
            onClickCancel
            , prevAction
            , nextAction
            // form
            , quotationSubscriptionFormA
            // reducer action
            , onVendorSelect
            , onCircuitTypeSelect
            , onContractTermSelect
            , onBandwidthSelect
        } = this.props;

        const { requestTypeOptions
            , preferredVendorOptions, allVendorSelected
            , circuitTypeOptions, allCircuitTypeSelected
            , contractTermOptions, allContractTermSelected
            , bandwidthOptions, allBandwidthSelected, showOtherBandwidthField } = this.props.quotationRequest;

        let disableSubmit = quotationSubscriptionFormA.quotationRequestTypeId == 0
            || quotationSubscriptionFormA.quotationVendorListIds.length == 0
            || quotationSubscriptionFormA.quotationCircuitTypeIds.length == 0
            || quotationSubscriptionFormA.quotationBandwidthIds.length == 0;

        disableSubmit = showOtherBandwidthField ? disableSubmit || quotationSubscriptionFormA.quotationBandwidthOther == '' : disableSubmit;

        return (
            <div>
                <Form method="post" role="form"
                    model="quotationSubscriptionFormA"
                    onSubmit={nextAction}
                >
                    <div >
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <Select
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('request_type')} *`}
                                    options={requestTypeOptions}
                                    placeholder={this.toLocaleLanguage('select_a_request_type')}
                                    fieldProp='.quotationRequestTypeId'
                                    value={quotationSubscriptionFormA.quotationRequestTypeId}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <ORFDropdownCheckbox
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('vendor')} *`}
                                    options={preferredVendorOptions}
                                    placeholder={this.toLocaleLanguage('select_a_vendor')} 
                                    action={onVendorSelect}
                                    selectedValues={quotationSubscriptionFormA.quotationVendorListIds}
                                    isSelectAll={allVendorSelected}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <ORFDropdownCheckbox
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('circuit_type')} *`}
                                    options={circuitTypeOptions}
                                    placeholder={this.toLocaleLanguage('select_circuit_type')} 
                                    action={onCircuitTypeSelect}
                                    selectedValues={quotationSubscriptionFormA.quotationCircuitTypeIds}
                                    isSelectAll={allCircuitTypeSelected}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <ORFDropdownCheckbox
                                    className="form-control"
                                    label={this.toLocaleLanguage('contract_terms')}
                                    options={contractTermOptions}
                                    placeholder={this.toLocaleLanguage('select_contract_terms')}
                                    action={onContractTermSelect}
                                    selectedValues={quotationSubscriptionFormA.quotationContractTermIds}
                                    isSelectAll={allContractTermSelected}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <ORFDropdownCheckbox
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('bandwidth')} *`}
                                    options={bandwidthOptions}
                                    placeholder={this.toLocaleLanguage('select_bandwidth')}
                                    action={onBandwidthSelect}
                                    selectedValues={quotationSubscriptionFormA.quotationBandwidthIds}
                                    isSelectAll={allBandwidthSelected}
                                />
                            </Col>
                        </Row>
                        {showOtherBandwidthField ?
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={this.toLocaleLanguage('other')}
                                        value={quotationSubscriptionFormA.quotationBandwidthOther}
                                        fieldProp='.quotationBandwidthOther'
                                    />
                                </Col>
                            </Row> : null
                        }
                        <div className="request-button-continer">
                            <div className="bottom-left">
                                <Button
                                    label={this.toLocaleLanguage('modal_close_cancel_button')}
                                    variant={"light"}
                                    action={onClickCancel}
                                />
                            </div>
                            <div className="bottom-right">
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('back')}
                                        variant={"outline-secondary"}
                                        action={prevAction}
                                    />
                                </div>
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('next_button')}
                                        variant={"primary"}
                                        type={"submit"}
                                        disabled={disableSubmit}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};
export default connect(
    state => {
        const { quotationRequest, translation } = state;
        const { quotationSubscriptionFormA } = state.form;
        return {
            quotationRequest
            , quotationSubscriptionFormA
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newQuotationActions),
            dispatch
        )
)(QuotationSubscriptionForm);